import { render, staticRenderFns } from "./VirtualAccountRechargeApply.vue?vue&type=template&id=183f150c&scoped=true&"
import script from "./VirtualAccountRechargeApply.vue?vue&type=script&lang=js&"
export * from "./VirtualAccountRechargeApply.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAccountRechargeApply.vue?vue&type=style&index=0&id=183f150c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f150c",
  null
  
)

export default component.exports